if (window.SparkleConfig.segment.writeKey) {
  (function () {
    "use strict";

    function trackExternalLinks(link, category, label) {
      try {
        analytics.track("Click", {
          category: category,
          label: label,
        });
      } catch (err) {}
    }

    function trackFormSubmission() {
      try {
        var name = document.URL;
        analytics.track("Submit", {
          category: "Sparkup Form",
          label: name,
        });
      } catch (err) {}
    }

    function trackVideo(video, action) {
      try {
        var source = video.prop("currentSrc");
        analytics.track(action, {
          category: "Video",
          label: source,
        });
      } catch (err) {}
    }

    function getLinkLanguage(url) {
      switch (true) {
        case /facebook\.com\/sharer/.test(url):
          return {
            network: "Facebook",
            action: "like",
          };

        case /twitter\.com\/intent/.test(url):
          return {
            network: "Twitter",
            action: "tweet",
          };

        case /plus\.google\.com\/share/.test(url):
          return {
            network: "Google+",
            action: "share",
          };

        case /www\.pinterest\.com\/pin\/create/.test(url):
          return {
            network: "Pinterest",
            action: "pin",
          };

        default:
          return {
            action: "External link",
          };
      }
    }

    function trackLink(url) {
      var linkLanguage;
      var categoryText;

      linkLanguage = getLinkLanguage(url);

      if (linkLanguage.network === undefined) {
        categoryText = linkLanguage.action;
      } else {
        trackSocial(linkLanguage.network, linkLanguage.action, url);
        categoryText = linkLanguage.network + " " + linkLanguage.action;
      }

      trackExternalLinks(this, categoryText, url);
    }

    function trackSocial(network, action, url) {
      try {
        window.ga("send", "social", network, action, url);
      } catch (err) {}
    }

    function openLinkInNewWindow(event) {
      if (
        this.hostname == window.SparkleConfig.sandbox.domainWithoutProtocol ||
        this.hostname == window.location.hostname
      ) {
        return true;
      }

      trackLink(this.href);

      window.open(this.href, "_blank").focus();
      return false;
    }

    jQuery(document).ready(function () {
      // External Link Tracking
      jQuery("body").on("click", 'a[href^="//"], a[href^="http://"], a[href^="https://"]', openLinkInNewWindow);

      // Track Forms
      jQuery("form.form-builder-form").on("submit", trackFormSubmission);

      // Track Video
      jQuery("video").on("loadedmetadata", function () {
        // Track the play event.
        jQuery("video").on("play", function () {
          trackVideo(jQuery(this), "Play");
        });

        // Track the pause event.
        jQuery("video").on("pause", function () {
          trackVideo(jQuery(this), "Pause");
        });

        // Track the seeked event. This gets fired when the currentTime is set. For instance it gets
        // triggered with a click on the time rail control.
        jQuery("video").on("seeked", function () {
          trackVideo(jQuery(this), "Seeked");
        });

        // Track the ended event.
        jQuery("video").on("ended", function () {
          trackVideo(jQuery(this), "Ended");
        });
      });

      jQuery(document).on("pjax:success", function () {
        try {
          analytics.page();
        } catch (err) {
          console.debug(err);
        }
      });
    });
  })();
}
